import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { AppConfigState } from '@nibtravel/shared/util/app-config';
import { PlanProduct, ProductCategory } from '@nibtravel/shared/util/gtm';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { PurchasePathDimensions } from '../custom-dimension/purchase-path-dimension.service';
import { PurchasePath } from './purchase-path.selectors';
import { get } from 'lodash-es';

@Injectable()
export class PlanAnlyticsService {
  constructor(
    private store: Store,
    private dimensionService: PurchasePathDimensions
  ) {}

  getProduct(): Observable<PlanProduct | undefined> {
    return combineLatest([
      this.store.select(PurchasePath.price),
      this.store.select(PurchasePath.planSummary),
      this.dimensionService.getDimension(),
    ]).pipe(
      map(([price, planSummary, dimensions]) => {
        if (!price || !planSummary) {
          return undefined;
        }
        const brand = this.store.selectSnapshot(AppConfigState.getBrand);
        const planPrice = price.basePrice.price;
        const campaignCode = price
          ? price.campaignDiscount
            ? this.store.selectSnapshot(PurchasePath.campaignCode)
            : undefined
          : '';
        const planPosition = this.store.selectSnapshot(
          PurchasePath.planPosition
        );
        return {
          id: planSummary.name,
          name: planSummary.name,
          quantity: 1,
          brand: brand,
          category: ProductCategory.Plan,
          price: planPrice,
          coupon: campaignCode,
          position: planPosition,
          currencyCode: get(planSummary, 'currencyCode', ''),
          ...dimensions,
        };
      })
    );
  }
}
